import React from "react";
import styles from "../styles.module.css"

export function TextBalloon(props: {text: JSX.Element}) {
    return (<div className={styles.BallonWrapper}>
        <div className={styles.Textballon}>{props.text}</div>
        <div className={styles.BallonDing}>▼</div>
    </div>)
}